var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardButtonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M256 0c70.69 0 134.7 28.66 181.02 74.98C483.34 121.31 512 185.32 512 256.01c0 70.68-28.66 134.69-74.98 181.01C390.7 483.34 326.68 512 256 512s-134.69-28.66-181.02-74.98C28.66 390.7 0 326.69 0 256.01c0-70.68 28.66-134.7 74.98-181.03C121.31 28.66 185.32 0 256 0zm110.47 269.8c10.3-9.17 10.02-17.33 0-26.62l-86.09-76.78c-11.21-7.03-22.9-2.9-22.59 11.73l.12 43.14-61.54-54.87c-11.2-7.03-22.89-2.9-22.59 11.73l.45 154.47c.96 15.86 10.01 20.21 23.37 12.87l60.51-53.95.12 41.08c.96 15.86 10.01 20.21 23.36 12.87l84.88-75.67zm46.28-170.55C372.64 59.15 317.22 34.33 256 34.33S139.36 59.15 99.26 99.25c-40.11 40.11-64.93 95.55-64.93 156.76 0 61.21 24.82 116.63 64.93 156.74 40.1 40.1 95.52 64.92 156.74 64.92 61.21 0 116.64-24.82 156.75-64.92 40.1-40.11 64.92-95.53 64.92-156.74 0-61.23-24.82-116.65-64.92-156.76z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardButtonIcon);
export default __webpack_public_path__ + "static/media/forward-button-icon.3749a362df1ddd75d3a750e8a98b95eb.svg";
export { ForwardRef as ReactComponent };